﻿import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { formatDate, CommonModule } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import { VoiceService } from '../../_services/voice/voice';

import * as CryptoJS from 'crypto-js';

import { Location } from '@angular/common';

export interface communicationtypelist {
  value: string;
  viewValue: string;
}

export interface categorylist {
  value: string;
  viewValue: string;
}

export interface novariablelistlist {
  value: string;
  viewValue: string;
}

export interface languagelist {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-voice-template-reg-details-by-pe',
  templateUrl: './voice-template-reg-details-by-pe.component.html',
  styleUrls: ['./voice-template-reg-details-by-pe.component.css']
})
export class VoiceTemplateRegDetailsBypeComponent implements OnInit {
  email: any;
  mobileno: any;
  showOTPfields: boolean;
  public entityId: any;
  makeRead: boolean;
  warningForNotMatchingEnitity: boolean;
  headerslist: any;
  selectedarray: any;
  urn: any;
  disableForm: boolean = false;
  filename: any;
  public submitted: boolean = false;
  public regsubmitted: boolean = false;
  Approver_EmailID: any;
  Approver_EntityID: any;
  csTempID: any
  csTempName: any;
  csTempContent: any
  ApprovedOrRejected: boolean = false;
 
  isReadOnly:Boolean=false

  UrnFromURL: any;
  constructor(private fb: FormBuilder,
    private es: APILoginService,
    private ls: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private vs: VoiceService,
  ) {
    this._route.params.subscribe((params) => {
      this.UrnFromURL = params['urn'];
    })
  }


  response: any;
  entitymodifyForm: FormGroup;
  selectedValue: String;
  telelist: any;
  industrylist: any;
  sectorlist: any;
  public govtlistdiv: boolean = false;


  get f() { return this.entitymodifyForm.controls; }





  attachmentList: any = [];


  languagelistitems: languagelist[] = [
    { value: 'English', viewValue: 'English' },
    { value: 'Hindi', viewValue: 'Hindi' },
  ];


  communicationtypelistitems: communicationtypelist[] = [
    { value: 'P', viewValue: 'Promotional' },
    { value: 'S', viewValue: 'Service' },
    { value: 'T', viewValue: 'Transactional' },
  ];

  categorylistitems: categorylist[] = [
    { value: '1', viewValue: 'Banking / Insurance / Financial Products / Credit cards' },
    { value: '2', viewValue: 'Real Estate' },
    { value: '3', viewValue: 'Education' },
    { value: '4', viewValue: 'Health' },
    { value: '5', viewValue: 'Consumer Goods and automobiles' },
    { value: '6', viewValue: 'Communication / Broadcasting / Entertainment / IT' },
    { value: '7', viewValue: 'Tourism / Leisure' },
    { value: '8', viewValue: 'Food and Beverages' },

  ];

  novariablelistlistitems: novariablelistlist[] = [
    { value: '0', viewValue: '0' },
    { value: '1', viewValue: '1' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
    { value: '9', viewValue: '9' },
    { value: '10', viewValue: '10' },
    { value: '11', viewValue: '11' },
    { value: '12', viewValue: '12' },
    { value: '13', viewValue: '13' },
    { value: '14', viewValue: '14' },
    { value: '15', viewValue: '15' },
    { value: '16', viewValue: '16' },
    { value: '17', viewValue: '17' },
    { value: '18', viewValue: '18' },
    { value: '19', viewValue: '19' },
    { value: '20', viewValue: '20' }

  ];


  ngOnInit() {

    this.entitymodifyForm = this.fb.group({
      Entity_ID: ['',],
      industry_type: ['',],
      Organization: ['',],
      communication_type: ['',],
      category: ['',],
      language: ['',],

      header_list: ['',],
      content_type: ['',],
      template_name: ['',],
      no_variables: ['',],
      template_content: ['',],
      docname: [''],
      desc_template: ['',],
      csTempID: ['',],
      csTempName: ['',],
      csTempContent: ['',],
      sample_content: [''],
      type_of_call: [''],
      justification: [''],
      checkbox: [true]


    });
   // console.log("dsdfdfds", this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS))
    if (this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS) == "PE") {
      this.ApprovedOrRejected = true;
    }
    this.getTemplateDetails();
    
  }

  showCSTinfo() {

    this.$modal.promptModal({
      title: "Consent Template Name: " + this.csTempName,
      msg: "Consent Template Content: " + this.csTempContent
    });
  }
  Preview() {
    console.log("called")
    let name = this.entitymodifyForm.get("template_name").value
    let contentinfo = this.entitymodifyForm.get("template_content").value

    this.$modal.promptModal({
      title: name,
      msg: contentinfo
    });
  }


  download(file1, Refno) {

    var data = {
      "Container": "voicetemplates",
      "URN": "1607" + Refno,
      "FileName": file1
    }

    console.log("-------file1--------", file1)
    this.vs.voiceTempfiledownload(data).subscribe(r => {

      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Voice Templates',
        msg: 'File has been downloaded Successfully'
      });
    })

  }
  backClicked() {
    console.log("clickedddddddddddd");
    this._location.back();
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  async getTemplateDetails() {
    await this._route.params.subscribe((params) => {
      this.urn = params['urn'];
    })
    console.log("URN", this.urn)
    let data = {

      "URN": this.urn
    }
   // console.log("data", data)
    this.vs.getVoiceTemplateDetails(data)
      .subscribe(r => {
        if (r.status == "success") {
          this.response = r.message;
          this.isReadOnly=true;

          this.entityId = r.message.ID;
          if (r.message.Hash_VoiceTMP_Doc) {
            let fullfilename = r.message.Hash_VoiceTMP_Doc.split(".")
            this.filename = fullfilename[fullfilename.length - 2]
            this.entitymodifyForm.controls['docname'].setValue(r.message.VoiceTemp_docName);

          }

        
          this.csTempID = r.message.CSTempID
          this.csTempName = r.message.CST_Name
          this.csTempContent = r.message.CST_Content

          this.entitymodifyForm.controls['communication_type'].setValue(r.message.VoiceTemp_CommunicationType);
          this.entitymodifyForm.controls['sample_content'].setValue(r.message.Sample_Content);
          this.entitymodifyForm.controls['category'].setValue(r.message.VoiceTemp_Category);
          this.entitymodifyForm.controls['language'].setValue(r.message.VoiceTemp_Language);
          this.entitymodifyForm.controls['header_list'].setValue(r.message.VoiceTemp_Header);
          this.entitymodifyForm.controls['type_of_call'].setValue(r.message.VoiceTemp_CallType);
          // this.entitymodifyForm.controls['header_list'].setValue(r.message.VoiceTemp_Header.toString());
          this.entitymodifyForm.controls['content_type'].setValue(r.message.Content_Type);
          this.entitymodifyForm.controls['template_name'].setValue(r.message.VoiceTemp_Name);
          this.entitymodifyForm.controls['no_variables'].setValue(r.message.VoiceTemp_Variables);
          this.entitymodifyForm.controls['template_content'].setValue(r.message.Sample_Content);
          this.entitymodifyForm.controls['desc_template'].setValue(r.message.VoiceTemp_Description);
          // this.entitymodifyForm.controls['restr_comments'].setValue(r.message.Registrar_comments);
          this.entitymodifyForm.controls['Organization'].setValue(r.message.Entity_Organization);
          this.entitymodifyForm.controls['Entity_ID'].setValue(r.message.Entity_ID);
          this.entitymodifyForm.controls['justification'].setValue(r.message.VoiceTemp_justification);
          this.entitymodifyForm.controls['industry_type'].setValue(r.message.E_Org_Type);
        }
        else if (r.status == "fail" && r.message == "Not found") {
          this.$modal.errorModal({
            title: 'Voice Content Template Details',
            msg: "Data not found"
          });
        }
        else {
          this.$modal.errorModal({
            title: 'Voice Content Template Details',
            msg: "Error Occured while retrieving Template Details"
          });

        }


      })


  }






}